import { render, staticRenderFns } from "./ai-simple.vue?vue&type=template&id=7aa1eb36&lang=pug&"
import script from "./ai-simple.vue?vue&type=script&lang=js&"
export * from "./ai-simple.vue?vue&type=script&lang=js&"
import style0 from "./ai-simple.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports